<template>
  <el-table
    :data="deptList"
    style="width: 100%"
    height="450"
    class="table-wrap"
  >
  <el-table-column
      prop="ksmc"
      label="预约科室"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column prop="ghrq" label="预约日期" align="center" width="120">
    </el-table-column>
    <el-table-column
      prop="numno"
      label="预约号"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
      prop="hosPatid"
      label="病案号"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>
    <!--:formatter="dateFilter"-->
    <el-table-column prop="hzxm" label="患者姓名" align="center"> </el-table-column>
    <el-table-column prop="Sex" label="患者性别" align="center"> </el-table-column>
    <el-table-column prop="Age" label="患者年龄" align="center"> </el-table-column>
    

    <el-table-column
      prop="sjh"
      label="患者手机号"
      align="center"
      show-overflow-tooltip
    >
    </el-table-column>

    
    <el-table-column
      prop="operation"
      label="操作"
      align="center"
      class="table-column"
      width="180"
    >
      <template slot-scope="scope">
        <div class="table-btn-wrap">
          <el-button
            size="small"
            type="primary"
            @click="linkToDetail(scope.row)"
          >
            本人接诊
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<style>
</style>
<script>
export default {
  data() {
    return {
      deptList: [],
    };
  },
  components: {},
  created() {
    this.getDeptList();
  },
  methods: {
    getAge(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      return year - idCardNum.substring(6, 10);
    },
    getSex(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      this.age = year - idCardNum.substring(6, 10);
      if (idCardNum.substring(16, 17) % 2 == 0) {
        return "女";
      } else return "男";
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    async getDeptList() {
      let that=this;
      let bdate = this.formatDate(new Date());
      let { code, obj } = await this.$http(
        "smarthos.online.outpatient.audit.wait.receive.list",
        {
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          bdate: bdate,
          edate: bdate,
        }
      );
      if(code == "0"){
        
        obj.list.forEach((item,index)=>{
            item.Sex=that.getSex(item.zjhm);
            item.Age=that.getAge(item.zjhm);
        })
        this.deptList = obj.list
      }
       
    },
    async accept(item) {
      let { code, obj } = await this.$http(
        "smarthos.yygh.doc.workstation.clinical.reception",
        {
          docname:JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName,
          docid: item.ysid,
          paymentid: item.ddid,
          hosid: item.yyid,
        }
      );
      if (code == "0") {
        this.$message.success("本人接诊成功");
        this.$emit("toOperate", true);
      }
    },
    linkToDetail(row) {
      let that = this;
      // return
      this.$confirm("您确定要本人接诊此患者,不可撤销, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.accept(row);
        })
        .catch(() => {
         
        });
    },
  },
};
</script>
